import { gql, MutationFunctionOptions, useMutation } from '@apollo/client';
import { UsageLimitEntitlementName } from '@jupiterone/entitlement-types';
import { Question } from '@jupiterone/jupiter-types';
import { useSnackbarNotification } from '../components/notifications/SnackbarNotificationContext';
import { useUsageLimitEntitlementAccessQuery } from '../entitlements';

export const DeleteQuestionMutation = gql`
  mutation DeleteQuestion($id: ID!) {
    deleteQuestion(id: $id) {
      id
      title
      description
      queries {
        query
        name
        version
      }
      compliance {
        standard
        requirements
        controls
      }
      variables {
        name
        required
        default
      }
      tags
      accountId
      integrationDefinitionId
      showTrend
      pollingInterval
    }
  }
`;

export type DeleteQuestionVariables = {
  id: string;
};

export type DeleteQuestionResponse = Question;

export const useDeleteQuestion = () => {
  const notification = useSnackbarNotification();
  const [deleteQuestion] = useMutation<
    DeleteQuestionResponse,
    DeleteQuestionVariables
  >(DeleteQuestionMutation);
  const customQuestionsEntitlement = useUsageLimitEntitlementAccessQuery({
    variables: {
      usageLimitEntitlementName: UsageLimitEntitlementName.CUSTOM_QUESTIONS,
    },
  });

  return async (
    options?:
      | MutationFunctionOptions<DeleteQuestionResponse, DeleteQuestionVariables>
      | undefined
  ) => {
    try {
      const deleteQuestionResponse = await deleteQuestion(options);
      await customQuestionsEntitlement.refetch();
      return deleteQuestionResponse;
    } catch (e) {
      notification.error({
        message: 'Error deleting question',
        error: e,
      });
    }
  };
};
